import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import LayoutModel from '@src/slide/domain/ui-model/element-modeles/layout-model';
import MasterModel from '@src/slide/domain/ui-model/element-modeles/master-model';
import SlideModel from '@src/slide/domain/ui-model/element-modeles/slide-model';
import type { ILayoutModel } from '@src/slide/domain/ui-model/element-modeles/Interface/layout-model.interface';
import type { IMasterModel } from '@src/slide/domain/ui-model/element-modeles/Interface/master-model.interface';
import type { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { PresentationPropertyType } from '@src/slide/domain/ui-model/element-modeles/factories/presentation-property-type';
import NoteModel from '@src/slide/domain/ui-model/element-modeles/note-model';
import { INoteModel } from '@src/slide/domain/ui-model/element-modeles/Interface/note-model.interface';
import SectionModel from '@src/slide/domain/ui-model/element-modeles/section-model';
import { ISectionModel } from '@src/slide/domain/ui-model/element-modeles/Interface/section-model.interface';
import ThemeModel from '@src/slide/domain/ui-model/element-modeles/theme-model';
import { IThemeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/theme-model.interface';

export type PageModel = ISlideModel | IMasterModel | ILayoutModel | INoteModel | ISectionModel | IThemeModel;

export function createPageModel(type: PresentationPropertyType): PageModel | undefined {
    switch (type) {
        case UIModelType.SLIDE:
            return new SlideModel();
        case UIModelType.MASTER:
            return new MasterModel() as IMasterModel;
        case UIModelType.LAYOUT:
            return new LayoutModel();
        case UIModelType.NOTE:
            return new NoteModel();
        case UIModelType.SECTION:
            return new SlideModel();
        case UIModelType.THEME:
            return new ThemeModel();
    }
}

export function getPageModelConstructorByType(type: PresentationPropertyType): (new () => PageModel) {
    switch (type) {
        case UIModelType.SLIDE:
            return SlideModel;
        case UIModelType.MASTER:
            // @ts-ignore todo: 看看能不能删了这个方法
            return MasterModel;
        case UIModelType.LAYOUT:
            return LayoutModel;
        case UIModelType.NOTE:
            return NoteModel;
        case UIModelType.SECTION:
            return SectionModel;
        case UIModelType.THEME:
            return ThemeModel;
    }
}
